<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text=""
          >
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" :fullscreen="true">
      <ion-grid fixed class="ion-padding">
        <ion-row>
          <ion-col>
            <div
              class="c-header u-bg-blue"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/icon_roodie_call.svg') +
                  ')',
              }"
            ></div>
            <p>
              <b>So einfach geht’s:</b>
            </p>
            <p v-if="from === 'chat'">
              <b>1. Kontaktaufnahme</b>
              <br />
              Ihr Roodie.Check wird mit Ihrer Zustimmung an BetterDoc übergeben,
              damit der passende Arzt für Sie gesucht werden kann.
            </p>
            <p v-else>
              <b>1. Kontaktaufnahme</b>
              <br />
              Machen Sie den
              <a
                href="#"
                @click.prevent="
                  $router.push({
                    name: 'home',
                    params: {
                      name: 'doctorsearch',
                      area: 'body-front',
                      shouldShowPaintype: false,
                      from: 'anleitungBetterDoc',
                    },
                  })
                "
                >Roodie.Check</a
              >, damit sich die Experten von BetterDoc im Vorfeld ein Bild von
              Ihrem gesundheitlichen Anliegen machen können oder buchen Sie
              einfach einen
              <a
                href="#"
                @click.prevent="$router.push({ name: 'betterdoc-kontakt' })"
                >Rückruf</a
              >. Sie können auch gerne selbst gleich
              <a href="tel: 08004446999">0800 4446999</a> anrufen.
            </p>
            <p>
              <b>2. Ein Experte von BetterDoc meldet sich</b>
              <br />
              Sollten noch Informationen nötig sein, so kontaktiert Sie ein
              fachlicher Experte von BetterDoc, um zu erfragen, was Ihnen bei
              der Arztwahl wichtig ist.
            </p>
            <p>
              <b>3. Arztempfehlung und Termin</b>
              <br />
              Spätestens nach 48 Stunden erhalten Sie 3 Empfehlungen für die
              Ärzte oder Kliniken, die optimal passen. Inklusive
              Terminvereinbarung.
            </p>
            <p>
              <b>4. Ihr Ansprechpartner von A – Z</b>
              <br />
              Während der kompletten ärztlichen Behandlung haben Sie einen
              persönlichen Ansprechpartner bei BetterDoc.
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonButtons,
  IonBackButton,
} from "@ionic/vue";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonButtons,
    IonBackButton,
  },
  props: {
    from: {
      required: false,
      default: "",
    },
  },
  data() {
    return {};
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
